import React, { Component } from 'react'
import { connect } from 'react-redux'

import { paymentIndexToggleTerminology } from '../../actions'

function mapStateToProps(state, hocProps) {
    const { module, id, block } = hocProps

    return {
        isTerminologyOpen: state.getIn(
            ['ui', 'workspace', module, id, 'blocks', block, 'customData', 'isTerminologyOpen'],
            false
        ),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps, { paymentIndexToggleTerminology })
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }
    return HocConnect
}
